import React, { useEffect } from 'react';
import { actions, ACTIONS_TYPES } from 'redux/local';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { _t, createLink } from 'utils';
import Shared from 'screens/shared';
import moment from 'moment';
import { RESOURCE_STATE, CPU_FAMILY, ROUTE } from 'constant';
import { getAssets } from 'themes/assets';
import EditForm from './edit';
import Tiles from './tiles';

export default ({ history, match }) => {
  const { dcId, id } = match?.params;

  const { [ACTIONS_TYPES.SERVER.GET]: server = {} } = useSelector((e) => e);
  const { properties = {}, metadata = {}, entities = {} } = server;
  const { volumes = {}, nics = {}, cdroms = {} } = entities;

  const isControlled = false;


  if (properties?.bootVolume?.id) {
    (volumes?.items || []).forEach((e) => {
      if (e?.id === properties?.bootVolume?.id) e.isBootable = true;
    });
  }

  if (properties?.bootCdrom?.id) {
    (cdroms?.items || []).forEach((e) => {
      if (e?.id === properties?.bootCdrom?.id) e.isBootable = true;
    });
  }

  const deleteHandler = () => {
    actions.server.delete({ dcId, id });
    history.push(createLink(ROUTE.DASHBOARD.DATA_CENTER, { id: dcId }));
  };

  useEffect(() => {
    actions.server.get({ dcId, id });
  }, [dcId, id]);

  const getPropertiesRows = () => {
    const cpuFamily = CPU_FAMILY[properties?.cpuFamily] || {};
    const assets = getAssets();

    return [
      [_t('Availability Zone'), properties?.availabilityZone?.replace('_', ' ')],
      [_t('CPU Family'), (
        <span>
          <img src={cpuFamily?.logo} style={{ width: 24, verticalAlign: 'middle' }} alt="CPU Logo" />
          {` ${cpuFamily?.name}`}
        </span>
      )],
      [_t('Cores'), properties?.cores],
      [_t('RAM'), `${properties?.ram / 1024}GB`],
      [_t('Last Updated'), moment(metadata?.lastModifiedDate).fromNow()],
      ...(!isControlled ? [] : [[
        _t('Managed By'), (
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <img src={assets.KubernatesLogo} style={{ width: 16 }} alt="kubernates logo" />
            <span style={{ margin: '3px 0px 0px 3px' }}>Kubernetes</span>
          </span>
        )]]),
    ];
  };

  return (
    <Shared.widgets.Page
      route={ROUTE.DASHBOARD.SERVER}
      strapTitle={properties?.name}
      strapSubTitle={<Shared.utilities.Status state={properties?.vmState} />}
      strapIcon="server"
      onDelete={deleteHandler}
      editForm={<EditForm serverProps={{ ...properties, ram: properties.ram / 1024 }} dcId={dcId} id={id} />}
      editAction={ACTIONS_TYPES.SERVER.UPDATE}
    >
      <Tiles />
      <Shared.widgets.Properties properties={getPropertiesRows()} title="Properties" />
      {!isControlled && (
        <Shared.components.BootableDevices bootDevice={{ ...properties.bootCdrom, ...properties.bootVolume }} />
      )}
      <Shared.components.Storages storages={volumes?.items || []} history={history} isShowAttachButton readonly={isControlled} />
      <Shared.components.Cdroms cdroms={cdroms?.items || []} history={history} readonly={isControlled} />
      <Shared.components.NICs nics={nics?.items || []} readonly={isControlled} {...{ history, dcId, serverId: id }} />
      {metadata?.state === RESOURCE_STATE.BUSY && <Redirect to={createLink(ROUTE.DASHBOARD.DATA_CENTER, { id: dcId })} />}
    </Shared.widgets.Page>
  );
};
